class RingSizePicker extends HTMLElement {
  connectedCallback() {
    this.refreshElements();
    this.productId = this.closest('variant-picker')?.dataset.productId;

    this.handleClick ??= (event) => {
      const button = event.target.closest?.('[data-ring-size-system]');
      if (button && this.contains(button)) this.activate(button.dataset.ringSizeSystem);
    };
    this.handleVariantUpdate ??= (event) => {
      if (event.detail?.data?.productId !== this.productId) return;

      requestAnimationFrame(() => {
        this.refreshElements();
        const rememberedSystem = window.ringSizePickerSystems?.get(this.productId);
        if (rememberedSystem) this.activate(rememberedSystem, false);
      });
    };

    this.addEventListener('click', this.handleClick);
    document.addEventListener('variant:update', this.handleVariantUpdate);

    const rememberedSystem = this.productId ? window.ringSizePickerSystems?.get(this.productId) : null;

    if (rememberedSystem) {
      this.activate(rememberedSystem, false);
    } else if (new URL(window.location.href).searchParams.has('variant')) {
      const checkedInput = this.querySelector('input:checked');
      const checkedLabel = checkedInput?.closest('[data-ring-size-value-system]');
      const selectedSystem = checkedLabel?.dataset.ringSizeValueSystem;

      if (selectedSystem) this.activate(selectedSystem, false);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    document.removeEventListener('variant:update', this.handleVariantUpdate);
  }

  refreshElements() {
    this.buttons = Array.from(this.querySelectorAll('[data-ring-size-system]'));
    this.values = this.querySelector('.ring-size-picker__values');
  }

  activate(system, selectFirst = true) {
    if (!system || !this.values) return;

    window.ringSizePickerSystems ??= new Map();
    if (this.productId) window.ringSizePickerSystems.set(this.productId, system);

    this.values.hidden = false;

    this.buttons.forEach((button) => {
      const isActive = button.dataset.ringSizeSystem === system;
      button.setAttribute('aria-expanded', String(isActive));
    });

    const labels = Array.from(this.querySelectorAll('[data-ring-size-value-system]'));
    labels.forEach((label) => {
      label.hidden = label.dataset.ringSizeValueSystem !== system;
    });

    if (!selectFirst) return;

    const checkedInput = this.querySelector('input:checked');
    const checkedSystem = checkedInput?.closest('[data-ring-size-value-system]')?.dataset.ringSizeValueSystem;
    if (checkedSystem === system) return;

    const firstAvailableInput = labels
      .find((label) => label.dataset.ringSizeValueSystem === system && label.querySelector('input:not([aria-disabled="true"])'))
      ?.querySelector('input');

    if (firstAvailableInput) {
      firstAvailableInput.checked = true;
      firstAvailableInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

if (!customElements.get('ring-size-picker')) {
  customElements.define('ring-size-picker', RingSizePicker);
}
